'use strict';

namespace Core {

    class ClickPublisher {

        private eventNamespace: string = 'clickpublisher';

        constructor (
            private $scope: ng.IScope,
            private broker: any
        ) {
        }

        init (element : ng.IAugmentedJQuery, eventName : string) {

            element.on(`click.${this.eventNamespace}`, (e) => {
                e.preventDefault();
                this.broker.publish(eventName);
            });

            this.$scope.$on('$destroy', () => {
                element.off(`click.${this.eventNamespace}`);
            });
        }

    }

    angular
        .module('core')
        .directive('clickPublisher', (): ng.IDirective => {

            return {
                scope: {},
                restrict: 'A',
                controller: ClickPublisher,
                controllerAs: 'cp',
                bindToController: {
                    toggleEvent: '='
                },
                link: (
                    scope: ng.IScope,
                    el: ng.IAugmentedJQuery,
                    attr: ng.IAttributes,
                    controller: ClickPublisher
                ) => {
                    controller.init(el, attr['clickPublisher']);
                }
            };

        });

}
